<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DuixKy/tc-custom/9781398448964.jpg?1718071579170" alt="This image is the cover for the book Recovery: Out in the Open"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Recovery: Out in the Open
      </h1>
      <p class="bookDescription body article font2">
        <p>Are you someone who is struggling to feel comfortable in your own skin? Please pick up this book. Are you someone who knows deep down that ‘there is more to life than this’? Please pick up this book. Are you struggling to find hope? Please pick up this book. When you are alone, you still can’t stand the company? Well, that’s brilliant! At least we know where to begin. Thank everything, and despite everything, you picked up this book.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Judith Clark
      </h2>
      
      <p class="authorDescription body article">Judith Clark has worked in addiction and mental health throughout her career in the UK and Sydney Australia. She has lived in the Blue Mountains and the northwest of England. Her own struggle with mental health and personal recovery process created, fertile ground in which to create the 'Beyond Addiction’ and ‘Beyond Limitation’ programs which became part of treatment programs both in Australia and the UK. Judith lives with her partner Mike, and her feline support system, Felix, and Smokey.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ba594ea